import { PButton } from "@porsche-design-system/components-react"
import type { LocalizedLink } from "@slfinrtl/ui-bff-routes"
import { useCallback, useContext, useState } from "react"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import { commonMessages } from "src/common/messages/common.messages"
import { ButtonGroup } from "src/components"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { OpenListing } from "./openListing/OpenListing"

const messages = defineMessages({
	headline: {
		defaultMessage: "Open Listing",
		id: "openListing.modal.headline",
	},
})

export interface OpenListingModalProps {
	links: LocalizedLink[]
}

type Props = ModalProps<OpenListingModalProps>

export const OpenListingModal = ({ id, modalProps }: Props) => {
	const { links } = modalProps
	const { hideModal } = useContext(ModalContext)
	const [selectedUrl, setSelectedUrl] = useState<string>(links?.[0].url)

	const { formatMessage } = useIntl()

	const hide = useCallback(() => hideModal(id), [hideModal, id])

	const onSubmit = useCallback(() => {
		if (!selectedUrl) {
			return
		}
		window.open(selectedUrl, "_blank")
	}, [selectedUrl])

	return (
		<Modal id={id} width="small" heading={formatMessage(messages.headline)}>
			<OpenListing links={links} selectedUrl={selectedUrl} onSelectedUrlChanged={setSelectedUrl} />

			<ButtonGroup>
				<PButton onClick={onSubmit}>
					<FormattedMessage {...commonMessages.open} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={hide}>
					<FormattedMessage {...formMessages.cancel} />
				</PButton>
			</ButtonGroup>
		</Modal>
	)
}
